import React from 'react';
import styled from 'styled-components';
import { colors, typography, spaces, boxShadows, borders } from '../../lib/styles';
import Box from '../../spa/core-components/Box';
import Scrollable from '../../components/Scrollable';
import { RelatedLinksSchema } from '../../components/Schema';

const StyledLinkItem = styled.a`
    background: ${colors.white};
    box-shadow: ${boxShadows.low};
    width: 100%;
    display: inline-block;
    color: ${colors.grey800};
    padding: ${spaces.space7}px ${spaces.space8}px;
    border-radius: ${borders.borderRadiuses.medium}px;
    line-height: ${typography.lineHeights.medium};

    &:hover,
    &:focus {
        text-decoration: none;
        color: ${colors.grey800};
        box-shadow: ${boxShadows.medium};
    }
`;

interface LinkItem {
    label: string;
    url: string;
}

type Columns = 1 | 2 | 3 | 4;

interface LinkGardenProps {
    data: LinkItem[];
    columns: Columns[];
}

const LinkGarden = ({ data, columns }: LinkGardenProps) => {
    const relatedLinksList = () => data.map((item) => item.url);

    return (
        <Scrollable
            variations={[
                `small-${columns[0]}-col`,
                `medium-${columns[1]}-col`,
                `normal-${columns[2]}-col`,
                `large-${columns[3]}-col`,
            ]}
        >
            <RelatedLinksSchema links={relatedLinksList()} />
            {data.map((item, index) => (
                <Box key={`item-${index}`} paddingBottom="space7">
                    <StyledLinkItem href={item.url}>{item.label}</StyledLinkItem>
                </Box>
            ))}
        </Scrollable>
    );
};

export default LinkGarden;
